import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AwsService, CreditosService, RolesService } from 'src/app/services/service.index';
import swal2 from 'sweetalert2';

@Component({
  selector: 'app-calculadora',
  templateUrl: './calculadora.component.html',
  styleUrls: ['./calculadora.component.css']
})
export class CalculadoraComponent implements OnInit {
  idu = '' ;
  calculoFG = new FormGroup({
    primerPago: new FormControl(false),
    pagoInicial: new FormControl(''),
    total: new FormControl(''),
  });
  terms = [];
  plazosSeleccionados = [];
  superAdmin = false;
  companies = [];
  company_id = '';
  idPPMensual = '';


  constructor(private creditosService: CreditosService,
    private rolesService: RolesService,
    private awsService: AwsService
  ) { }

  ngOnInit(): void {
    this.idu = localStorage.getItem('uid');
    let date = new Date();
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let completeDate = year + '-' + month + '-' +day;
    var primer = 0;
    if(this.calculoFG.get('primerPago')?.value){
      primer = 1;
    }

    this.creditosService.getperiodosPagos().subscribe(resp => {
      var paymentPeriods = [];
      resp.forEach(p => {
        paymentPeriods.push(p.attributes);
      })
      this.idPPMensual = paymentPeriods.find(p => p.key == 'Mensual').id;
    })

    this.creditosService.getCondiciones().subscribe(resp => {
      this.terms = resp.sort(((a, b) => a.value - b.value));;
      this.plazosSeleccionados = [];
      /* this.terms.forEach(t => {
        this.plazosSeleccionados.push(t.value);
      }) */
    })

    var rol = localStorage.getItem('rid');

    this.rolesService.getRol(rol).subscribe(resp => {
      var role = resp[0];
      if(role.name == 'SuperAdmin'){
        this.awsService.getCompanyes().subscribe(resp => {
          this.companies = resp;
          this.superAdmin = true;
        });
      }

    }); 
  }

  changePP(){
    this.calculoFG.patchValue({primerPago: !this.calculoFG.get('primerPago')?.value});
  }

  seleccionarPlazo(plazo, group){
    if(!this.plazosSeleccionados.includes(plazo)){
        this.plazosSeleccionados.push(plazo);
    }else{
      var indice = this.plazosSeleccionados.indexOf(plazo);
      this.plazosSeleccionados.splice(indice, 1);
    }
  }

  fmCurrency(control) {
    let value = this.calculoFG.get(control)?.value || '';

    // elimino caracteres no numericos excepto el punto decimal
    value = value.replace(/[^0-9.]/g, '');

    // mantengo solo el primer decimal
    const parts = value.split('.');
    if (parts.length > 2) {
      value = parts[0] + '.' + parts.slice(1).join('');
    }

    // formateo y limito a solo dos decimales
    let [integerPart, decimalPart] = value.split('.');
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    decimalPart = (decimalPart || '').padEnd(2, '0').substring(0, 2);

    // actualizo visualmente
    this.calculoFG.get(control)?.setValue(`${integerPart}${decimalPart ? '.' + decimalPart : ''}`) ;
    console.log(`${control}`, this.calculoFG.get(control)?.value);
  }

  validateInput(control) {
    let value = this.calculoFG.get(control)?.value || '';

    const parts = value.split('.');
    if (parts.length === 2) {
      parts[1] = parts[1].substring(0, 2);
      value = parts.join('.');
    }

    this.calculoFG.get(control)?.setValue(value);
  }

  getFormattedValue(value: string): string {
    const valuer = value.replace(/,/g, '');
    
    // busco el punto decimal
    const decimalIndex = valuer.indexOf('.');
    
    if (decimalIndex !== -1) {
        // trunco a dos y no redondeo
        return valuer.substring(0, decimalIndex + 3); 
    }
    
    // si no hubiera decimal retorno el valor
    return valuer;
}

  calcular(){
    swal2.showLoading();
    let date = new Date();
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let start_date;

    if(month < 10){
      start_date =  `${year}-0${month}-${day}`;
    }else{
      start_date = `${year}-${month}-${day}`;
    }
    var customer_credits = [];
    this.plazosSeleccionados.forEach(p => {
      customer_credits.push(
        { 
          "term_id": this.terms.find(t => t.value == p).id, 
          "payment_period_id": this.idPPMensual, 
          "user_id": localStorage.getItem('uid'), 
          "currency": "PESOS", 
          "residual_value": 1,
        }
      )
    });


    var params = {
      inicial_payment: this.getFormattedValue(this.calculoFG.get('pagoInicial')?.value),
      late_payment: this.calculoFG.get('primerPago')?.value ? 1 : 0,
      company_id: this.company_id,
      quote: {
        total: this.getFormattedValue(this.calculoFG.get('total')?.value),
        date: start_date,
        status: "SI",
        user_vendor_id: localStorage.getItem('uid'),
        user_customer_id: "",
        name: "",
        mail: ""
      },
      customer_credits: customer_credits
    }
    this.creditosService.creditCalculator(params).subscribe(resp => {
      swal2.close();
      swal2.fire({
        title: "Cotización creada correctamente",
        icon: "success",
        html: `
          <div class="row">
            <div class="col">
              <a title="Descargar" class="btn btn-white btn-icon mb-3 mb-sm-0" href="${resp['attached']}" download>
                  <span class="btn-inner--icon"><i class="material-icons">file_download</i></span>
              </a>
            </div>
          </div>

          <div class="row mt-3" style="text-align: center;">
            <input id="url" class="form-control" value="${resp['attached']}" style="width: 80%;">
            <a style="width: 20%;" class="btn btn-white btn-icon mb-3 mb-sm-0" onclick="navigator.clipboard.writeText('${resp['attached']}')">
                <span class="btn-inner--icon"><i class="material-icons">content_copy</i></span>
            </a>
          </div>
        `,
        showCloseButton: false,
        showCancelButton: false,
        allowOutsideClick: false
      }).then(res => {
        if(res.value){
          swal2.close();
          location.reload();
          this.ngOnInit();
        }
      });
    }, err => {
      console.log(err);
      try{
        swal2.fire('Atención', err.error.errors[0], 'info');
      }catch{
        swal2.fire('Atención', 'Algo salió mal', 'info');
      }
    })
  }

}
